export default "__VITE_ASSET__BruzbPeX__"